/**
 * Publishes the Pandectes consent bar's height as `--cookie-bar-height` on <html>, so fixed UI
 * can sit above it instead of underneath. Ported from the previous theme, which solved the same
 * collision for Freshchat and the AI shopping button.
 *
 * The banner lives in a shadow root and Pandectes exposes no JS API for its size, so the
 * element has to be discovered by polling before a ResizeObserver can take over.
 */

const DISCOVERY_INTERVAL = 100;
const DISCOVERY_TIMEOUT = 10000;

/** @param {number} height */
function publishHeight(height) {
  document.documentElement.style.setProperty('--cookie-bar-height', `${Math.round(height) || 0}px`);
}

/** @param {HTMLElement} dialog */
function watch(dialog) {
  new ResizeObserver(() => publishHeight(dialog.offsetHeight)).observe(dialog);
  publishHeight(dialog.offsetHeight);
}

const discover = setInterval(() => {
  const dialog = document.querySelector('pandectes-cmp')?.shadowRoot?.querySelector('dialog');
  if (!(dialog instanceof HTMLElement)) return;

  clearInterval(discover);
  watch(dialog);
}, DISCOVERY_INTERVAL);

// Give up if the banner never appears — a returning shopper has already consented.
setTimeout(() => clearInterval(discover), DISCOVERY_TIMEOUT);
